import { Button, useTheme } from "@mui/material";

const CustomButton = ({
    label,
    onClick,
    variant='contained',
    startIcon=null,
    endIcon=null,
    needAnimation=false,
    ...other
}) => {
    const theme = useTheme();

    return (
        <>
            <Button 
                variant={variant}
                onClick={onClick}
                disabled={!onClick}
                sx={{
                    textTransform: 'none',
                    borderRadius: 50,
                    fontWeight: 600,
                    px: 2,
                    py: 1,
                    '&: hover': {
                        transform: !needAnimation ? 'scale(0.95)' : 'none',
                        backgroundColor: theme.palette.primary.main
                    },
                    animation: needAnimation ? 'bounceAnimation 1s infinite' : 'none'
                }}
                startIcon={startIcon}
                endIcon={endIcon}
                {...other}
            >
                {label}
            </Button>
        </>
    );
}

export default CustomButton;